/* Homepage finder: category, colour, size and price chips; the button never shows a quantity. See sections/mym-finder.liquid. */
(() => {
  // colour families: a family matches every colour value that contains one of its words (values are Arabic on /ar)
  const COLORS = [
    { k: 'black', en: 'Black', ar: 'أسود', hex: '#0F0C0A', words: ['BLACK', 'ONYX', 'أسود'] },
    { k: 'brown', en: 'Brown', ar: 'بني', hex: '#6B4A36', words: ['BROWN', 'BRWON', 'CHOCOLATE', 'MOCHA', 'SIENNA', 'CAMEL', 'COFFEE', 'TAUPE', 'TAN', 'COPPER', 'RUST', 'بني', 'براون', 'شوكولاتة', 'موكا', 'سيينا', 'نحاس', 'صدئي'] },
    { k: 'beige', en: 'Beige', ar: 'بيج', hex: '#D8C4AA', words: ['BEIGE', 'WHEAT', 'BURLYWOOD', 'KHAKI', 'NUDE', 'SAND', 'PEACH PUFF', 'بيج', 'قمح', 'بورليوود', 'كاكي', 'خوخي'] },
    { k: 'white', en: 'White', ar: 'أبيض', hex: '#F7F3EC', words: ['WHITE', 'IVORY', 'CREAM', 'أبيض', 'عاجي'] },
    { k: 'grey', en: 'Grey', ar: 'رمادي', hex: '#9A958F', words: ['GREY', 'GRAY', 'SILVER', 'رمادي', 'فضي'] },
    { k: 'green', en: 'Green', ar: 'أخضر', hex: '#4F5E45', words: ['GREEN', 'OLIVE', 'TEAL', 'AQUAMARINE', 'SAGE', 'MINT', 'أخضر', 'زيتي', 'زيتوني'] },
    { k: 'blue', en: 'Blue', ar: 'أزرق', hex: '#2E3F5C', words: ['BLUE', 'NAVY', 'TURQUOISE', 'أزرق', 'كحلي', 'فيروزي'] },
    { k: 'red', en: 'Burgundy & red', ar: 'عنابي وأحمر', hex: '#6E2232', words: ['BURGUNDY', 'MAROON', 'RED', 'WINE', 'BORDEAUX', 'عنابي', 'ماروني', 'أحمر'] },
    { k: 'pink', en: 'Pink', ar: 'وردي', hex: '#D7A1A6', words: ['PINK', 'ROSE', 'FUCHSIA', 'FUCHIA', 'BLUSH', 'SALMON', 'CORAL', 'وردي', 'فوشيا', 'سلمون', 'مرجان'] },
    { k: 'purple', en: 'Purple', ar: 'بنفسجي', hex: '#6B5378', words: ['PURPLE', 'LAVENDER', 'VIOLET', 'PLUM', 'LILAC', 'THISTLE', 'بنفسجي', 'خزامى', 'برقوق', 'أرجواني', 'بيربل'] }
  ];
  // sizes: values read like 'S-54"', 'S/M-56"' or 'FREESIZE-58"'; 'S/M' counts for both S and M
  const SIZES = [
    { k: 'XS', ar: 'XS' }, { k: 'S', ar: 'S' }, { k: 'M', ar: 'M' }, { k: 'L', ar: 'L' }, { k: 'XL', ar: 'XL' },
    { k: 'FREE', en: 'Free size', ar: 'مقاس موحّد' }
  ];
  const BANDS = {
    fashion: [[0, 999.99], [1000, 1500], [1500, 2500], [2500, null]],
    small: [[0, 249.99], [250, 500], [500, 1000], [1000, null]]
  };
  const fmt = (n) => n.toLocaleString('en-US');
  const decoder = document.createElement('textarea');
  const decode = (v) => { decoder.innerHTML = v; return decoder.value; };
  // on /ar the values are translated: '⁦S/M⁩، الطول ⁦55⁩ بوصة', 'مقاس موحّد، الطول …', 'مقاس حر-56"'; the bidi marks are dropped first
  const sizeKeys = (v) => {
    const head = String(v).replace(/[\u2066-\u2069\u200e\u200f]/g, '').toUpperCase().split(/[-،,]/)[0].replace(/\s+/g, '');
    if (/^FRE+SIZE|^FREE|^ONESIZE|^مقاسموح|^مقاسحر|^قياسحر/.test(head)) return ['FREE'];
    return head.split('/').filter((t) => ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'].includes(t)).map((t) => (t === 'XXS' ? 'XS' : t === 'XXL' ? 'XL' : t));
  };
  const colorKey = (v) => {
    const up = String(v).toUpperCase();
    const fam = COLORS.find((c) => c.words.some((w) => up.includes(w)));
    return fam ? fam.k : null;
  };

  const init = (root) => {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = '1';
    const ar = root.dataset.locale === 'ar';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cats = [...root.querySelectorAll('[data-finder-row="category"] .finder__chip')];
    const rows = { color: root.querySelector('[data-finder-row="color"]'), size: root.querySelector('[data-finder-row="size"]'), price: root.querySelector('[data-finder-row="price"]') };
    const boxes = { color: root.querySelector('[data-finder-chips="color"]'), size: root.querySelector('[data-finder-chips="size"]'), price: root.querySelector('[data-finder-chips="price"]') };
    const go = root.querySelector('[data-finder-go]');
    const goLabel = root.querySelector('[data-finder-go-label]');
    const clear = root.querySelector('[data-finder-clear]');
    const status = root.querySelector('[data-finder-status]');
    const cache = new Map();
    let state = { cat: cats[0], color: null, size: null, price: null };
    let facets = { color: [], size: [] };
    let ctrl = null;
    let shown = null;

    const load = (url) => {
      if (cache.has(url)) return cache.get(url);
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const p = fetch(url, { signal: ctrl.signal, credentials: 'same-origin' })
        .then((r) => r.text())
        .then((html) => {
          const m = html.match(/<script type="application\/json" data-finder-data>([\s\S]*?)<\/script>/);
          if (!m) return null;
          const d = JSON.parse(m[1]);
          // filter values arrive HTML-escaped (S-52&quot;); the URL needs the plain value
          ['color', 'size'].forEach((g) => { d[g] = (d[g] || []).map(([v, n]) => [decode(v), n]); });
          return d;
        });
      cache.set(url, p);
      p.catch(() => cache.delete(url));
      return p;
    };

    const params = (s = state) => {
      const q = new URLSearchParams();
      if (s.color) facets.color.filter(([v]) => colorKey(v) === s.color).forEach(([v]) => q.append('filter.v.option.color', v));
      if (s.size) facets.size.filter(([v]) => sizeKeys(v).includes(s.size)).forEach(([v]) => q.append('filter.v.option.size', v));
      if (s.price) {
        const [lo, hi] = s.price;
        if (lo) q.set('filter.v.price.gte', lo);
        if (hi) q.set('filter.v.price.lte', hi);
      }
      return q;
    };
    const dataUrl = (q) => state.cat.dataset.url + '?section_id=mym-finder-data' + (q.toString() ? '&' + q.toString() : '');

    const chip = (label, key, group, extra) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'finder__chip' + (extra ? ' ' + extra : '');
      b.setAttribute('aria-pressed', 'false');
      b.dataset.key = key;
      b.dataset.group = group;
      b.innerHTML = label;
      return b;
    };
    const stagger = (box) => [...box.children].forEach((el, i) => { el.style.setProperty('--i', i); });

    const showRow = (row, on) => {
      if (on === !row.hidden) return;
      row.hidden = !on;
      if (on && !reduce) { row.classList.remove('is-entering'); void row.offsetWidth; row.classList.add('is-entering'); }
    };

    const buildFacetChips = () => {
      // colour
      const famCounts = {};
      facets.color.forEach(([v, n]) => { const k = colorKey(v); if (k) famCounts[k] = (famCounts[k] || 0) + n; });
      boxes.color.innerHTML = '';
      COLORS.filter((c) => famCounts[c.k]).forEach((c) => {
        const b = chip(`<span class="finder__dot" style="background:${c.hex}" aria-hidden="true"></span>${ar ? c.ar : c.en}`, c.k, 'color');
        boxes.color.appendChild(b);
      });
      if (state.color && !famCounts[state.color]) state.color = null;
      showRow(rows.color, boxes.color.children.length > 1);
      // size
      const sizeCounts = {};
      facets.size.forEach(([v, n]) => sizeKeys(v).forEach((k) => { sizeCounts[k] = (sizeCounts[k] || 0) + n; }));
      boxes.size.innerHTML = '';
      SIZES.filter((s) => sizeCounts[s.k]).forEach((s) => boxes.size.appendChild(chip(ar ? s.ar : (s.en || s.k), s.k, 'size', s.k === 'FREE' ? '' : 'finder__chip--size')));
      if (state.size && !sizeCounts[state.size]) state.size = null;
      showRow(rows.size, boxes.size.children.length > 1);
      // price steps depend on the category
      const bands = BANDS[state.cat.dataset.bands] || BANDS.fashion;
      boxes.price.innerHTML = '';
      bands.forEach(([lo, hi], i) => {
        const a = fmt(lo), b = hi ? fmt(Math.round(hi)) : '';
        let label;
        if (!lo) label = ar ? `أقل من ${fmt(Math.round(hi))} ر.س` : `Under SR ${fmt(Math.round(hi))}`;
        else if (!hi) label = ar ? `أكثر من ${a} ر.س` : `Over SR ${a}`;
        else label = ar ? `<bdi dir="ltr">${a}–${b}</bdi> ر.س` : `SR ${a}–${b}`;
        boxes.price.appendChild(chip(`<bdi>${label}</bdi>`, String(i), 'price'));
      });
      Object.values(boxes).forEach(stagger);
      paint();
    };

    const paint = () => {
      cats.forEach((c) => c.setAttribute('aria-checked', c === state.cat ? 'true' : 'false'));
      root.querySelectorAll('[data-group]').forEach((b) => {
        const g = b.dataset.group;
        const on = g === 'price' ? state.price && state.price.i === b.dataset.key : state[g] === b.dataset.key;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      clear.hidden = !(state.color || state.size || state.price);
    };

    // no quantity on the button for anyone, staff included (Youssef, 21 Oct 10:32); the data is 0 (none) or 1 (some)
    const tick = (n) => {
      const label = n === 0
        ? (ar ? 'لا توجد قطع، جرّبي خياراً آخر' : 'No pieces — try another')
        : (ar ? 'عرض القطع' : 'Show pieces');
      go.classList.toggle('is-empty', n === 0);
      go.setAttribute('aria-disabled', n === 0 ? 'true' : 'false');
      status.textContent = label;
      if (shown === label) return;
      shown = label;
      if (reduce) { goLabel.textContent = label; return; }
      goLabel.classList.add('is-out');
      setTimeout(() => { goLabel.textContent = label; goLabel.classList.remove('is-out'); }, 160);
    };

    const refresh = () => {
      const q = params();
      go.href = state.cat.dataset.url + (q.toString() ? '?' + q.toString() : '');
      go.classList.add('is-loading');
      load(dataUrl(q)).then((d) => {
        go.classList.remove('is-loading');
        if (d) tick(d.count);
      }).catch(() => go.classList.remove('is-loading'));
    };

    const selectCat = (c) => {
      state = { cat: c, color: state.color, size: state.size, price: null };
      go.href = c.dataset.url;
      go.classList.add('is-loading');
      load(dataUrl(new URLSearchParams())).then((d) => {
        go.classList.remove('is-loading');
        if (!d) return;
        facets = { color: d.color || [], size: d.size || [] };
        buildFacetChips();
        refresh();
      }).catch(() => go.classList.remove('is-loading'));
      paint();
    };

    root.addEventListener('click', (e) => {
      const c = e.target.closest('[data-finder-row="category"] .finder__chip');
      if (c) { if (c !== state.cat) selectCat(c); return; }
      const b = e.target.closest('[data-group]');
      if (b) {
        const g = b.dataset.group;
        if (g === 'price') {
          const band = (BANDS[state.cat.dataset.bands] || BANDS.fashion)[+b.dataset.key];
          state.price = state.price && state.price.i === b.dataset.key ? null : Object.assign([band[0], band[1]], { i: b.dataset.key });
        } else {
          state[g] = state[g] === b.dataset.key ? null : b.dataset.key;
        }
        paint();
        refresh();
        return;
      }
      if (e.target.closest('[data-finder-clear]')) { state.color = state.size = state.price = null; paint(); refresh(); return; }
      if (e.target.closest('[data-finder-go]') && go.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });
    // arrow keys move between category radios
    root.querySelector('[data-finder-row="category"] .finder__chips').addEventListener('keydown', (e) => {
      const i = cats.indexOf(document.activeElement);
      if (i < 0) return;
      const dir = (e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0) * (ar ? -1 : 1);
      if (!dir) return;
      e.preventDefault();
      const n = cats[(i + dir + cats.length) % cats.length];
      n.focus();
      selectCat(n);
    });
    cats.forEach((c) => c.setAttribute('tabindex', c === state.cat ? '0' : '-1'));
    root.addEventListener('focusin', () => cats.forEach((c) => c.setAttribute('tabindex', c === state.cat ? '0' : '-1')));

    selectCat(state.cat);
    root.classList.add('is-ready');
  };

  const start = () => document.querySelectorAll('[data-finder]').forEach((root) => {
    if (!('IntersectionObserver' in window)) return init(root);
    const io = new IntersectionObserver((entries) => {
      if (entries.some((en) => en.isIntersecting)) { io.disconnect(); init(root); }
    }, { rootMargin: '400px 0px' });
    io.observe(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
